if (!customElements.get('ops-mobile-purchase')) {
  customElements.define('ops-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.original = this.section?.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
      this.info = this.section?.querySelector('product-info');
      this.button = this.querySelector('[data-ops-mobile-submit]');
      if (!this.original || !this.info || !this.button) return;
      this.update = this.update.bind(this);
      this.onClick = (event) => {
        if (this.original.disabled || this.original.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        const field = this.info.querySelector('input:invalid, select:invalid, textarea:invalid');
        if (field) {
          event.preventDefault();
          field.scrollIntoView({ block: 'center', behavior: 'smooth' });
          field.focus({ preventScroll: true });
          field.reportValidity();
          return;
        }
      };
      this.button.addEventListener('click', this.onClick);
      this.media = window.matchMedia('(max-width: 749px)');
      this.media.addEventListener('change', this.update);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      this.media?.removeEventListener('change', this.update);
      this.button?.removeEventListener('click', this.onClick);
    }
    update() {
      const rect = this.original.getBoundingClientRect();
      const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden])');
      this.hidden = !this.media.matches || rect.bottom >= 0 || Boolean(error);
      const disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      const sourcePrice = this.info.querySelector('.price-item--sale:not(.price-item--regular)');
      const price = this.info.querySelector('.price.price--on-sale') ? sourcePrice : this.info.querySelector('.price-item--regular');
      const targetPrice = this.querySelector('[data-ops-mobile-price]');
      const availability = this.querySelector('[data-ops-mobile-availability]');
      const sourceAvailability = this.info.querySelector('[data-ops-availability]');
      if (price && targetPrice.textContent.trim() !== price.textContent.trim()) targetPrice.textContent = price.textContent.trim();
      const stockText = this.info.querySelector('.ops-delivery[hidden]') ? window.variantStrings.unavailable : sourceAvailability?.textContent.trim() || '';
      if (availability.textContent !== stockText) availability.textContent = stockText;
      // Use the original translated label when unavailable or in flight.
      if (disabled) this.button.textContent = this.original.querySelector('span')?.textContent.trim() || '';
      else this.button.textContent = document.documentElement.lang.startsWith('en') ? 'Add to cart' : 'In winkelwagen';
    }
  });
}
